export default __webpack_public_path__ + "static/media/HAB3.f9fbeb11.webp";